var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.857 9.143H9.143v5.714C9.143 15.486 8.629 16 8 16a1.146 1.146 0 0 1-1.143-1.143V9.143H1.143A1.146 1.146 0 0 1 0 8c0-.629.514-1.143 1.143-1.143h5.714V1.143C6.857.514 7.371 0 8 0s1.143.514 1.143 1.143v5.714h5.714C15.486 6.857 16 7.371 16 8s-.514 1.143-1.143 1.143Z",
    fill: "#fff"
  })));
};
export default SvgAddIcon;